module.exports = __webpack_public_path__ + "static/media/choithramsAccountG.f03db5f9.png";